export default "__VITE_ASSET__DW1zr50S__"